<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path d="M9.79042 16.2222C7.12144 15.7494 2.9705 10.2741 3.11373 6.02727C3.17235 4.28942 5.56114 3.01294 6.34028 2.65644L8.87356 6.65648L7.05286 7.89994C6.69478 9.41897 8.65694 11.9208 9.92115 12.3462L12.2697 10.9469L14.8285 14.6865C14.6879 15.0646 12.5368 16.7087 9.79042 16.2222Z" fill="#222222"/>
  </svg>
</template>
